const API_BASE_PATH = '/app-api/internal';

export {API_BASE_PATH};
